import QuestionBlock from "../components/QuestionBlock";
import SectionCard from "../components/SectionCard";
import "../styles/style.css";

export default function Step4({ data, onChange, onNext, onBack }) {

   const isValid =
    data.imovel &&
    data.tipoMoradia &&
    data.abastecimentoAguaPublica &&
    data.coletaEsgoto;


  return (
    <>
    <SectionCard
          title="Condições de Moradia"
          description="Responda às perguntas abaixo com atenção. Suas respostas são confidenciais e serão utilizadas exclusivamente para fins educacionais."
          items={[
            { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
          ]}
        > </SectionCard>

      <QuestionBlock
        name="imovel"
        title="O imóvel em que você mora é:"
        subtitle="(Resposta única)"
        options={[
          "Próprio",
          "Alugado",
          "Cecido",
          "Financiado"
        ]}
        selected={data.imovel}
        onSelect={(value) => onChange({ imovel: value })}
      />
        <QuestionBlock
        name="tipoMoradia"
        title="Qual é o tipo de moradia em que você reside?"
        subtitle="(Resposta única)"
        options={[
          "Casa",
          "Apartamento",
          "Construção Simples",
          "Vila"
        ]}
        selected={data.tipoMoradia}
        onSelect={(value) => onChange({ tipoMoradia: value })}
      />
      <QuestionBlock
        name="abastecimentoAguaPublica"
        title="A residência possui abastecimento de água pública?"
        subtitle="(Resposta única)"
        options={[
          "Sim",
          "Não"
        ]}
        selected={data.abastecimentoAguaPublica}
        onSelect={(value) => onChange({ abastecimentoAguaPublica: value })}
      />
<QuestionBlock
        name="coletaEsgoto"
        title="A residência possui coleta de esgoto?"
        subtitle="(Resposta única)"
        options={[
          "Sim",
          "Não"
        ]}
        selected={data.coletaEsgoto}
        onSelect={(value) => onChange({ coletaEsgoto: value })}
      />
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>

        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!isValid}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
